import { useSharedFunction } from 'frontlink';
import { PositionSettings } from '../../api/ack-link';
import { useRef, useState } from 'react';

export function RestrictedZonesPreview({ userID }: { userID: string }) {
	const [zones, setZones] = useState<Array<PositionSettings>>([]);
	const clearTimer = useRef<number>(0);
	useSharedFunction(`previewRestrictedZones::${userID}`, (data: { RestrictedZones: Array<PositionSettings> }) => {
		console.log('previewing restricted zones', data);
		setZones(data.RestrictedZones);
		clearTimeout(clearTimer.current);
		clearTimer.current = setTimeout(() => {
			setZones([]);
		}, 5_000);
	});

	if (!zones.length) {
		return null;
	}

	console.log('rendering');

	return (
		<div className="absolute top-0 w-screen h-screen">
			<div className="w-full h-full relative">
				{zones.map((zone, idx) => {
					return (
						<div
							key={idx}
							className="absolute flex items-center justify-center bg-red-500 bg-opacity-70"
							style={{
								top: zone.Y,
								left: zone.X,
								width: zone.Width,
								height: zone.Height,
							}}
						>
							<div className="text-red-100 text-[72px] font-medium">Zone {idx + 1}</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
